import { createAction, createPayloadAction, RequestAction, createRequestActionCreators } from 'helpers/actionsHelpers'
import { SimpleAction, PayloadAction } from 'interfaces/action'
import { PopupRelationId, RelationId, PeergroupPopupDetails } from 'interfaces/peergroups'
import { SidebarState, NavigationCountersActual, NavigationCountersStash } from 'interfaces/sidebar'

// should have destroy(FORM_CREATE_CUSTOM_PEER_GROUP) before itself
export const SHOW_PEER_GROUP_CREATE_FORM = 'SHOW_PEER_GROUP_CREATE_FORM' as const
type ShowPeergroupCreateForm = SimpleAction<typeof SHOW_PEER_GROUP_CREATE_FORM>
export const showPeergroupCreateFormActionCreator = (): ShowPeergroupCreateForm =>
  createAction(SHOW_PEER_GROUP_CREATE_FORM)

// should have destroy(FORM_EDIT_CUSTOM_PEER_GROUP) before itself
export const SHOW_PEER_GROUP_EDIT_FORM = 'SHOW_PEER_GROUP_EDIT_FORM' as const
type ShowPeergroupEditForm = PayloadAction<typeof SHOW_PEER_GROUP_EDIT_FORM, RelationId>
export const showPeergroupEditFormActionCreator = (relationId: RelationId): ShowPeergroupEditForm =>
  createPayloadAction(SHOW_PEER_GROUP_EDIT_FORM, relationId)

export const CLOSE_PEER_GROUP_FORM = 'CLOSE_PEER_GROUP_FORM' as const
type ClosePeergroupForm = SimpleAction<typeof CLOSE_PEER_GROUP_FORM>
export const closePeergroupFormActionCreator = (): ClosePeergroupForm =>
  createAction(CLOSE_PEER_GROUP_FORM)

export const EDIT_RELATION = 'EDIT_RELATION' as const
type EditRelation = PayloadAction<typeof EDIT_RELATION, RelationId>
export const editRelationActionCreator = (payload: RelationId) =>
  createPayloadAction(EDIT_RELATION, payload)

export const SHOW_PEERGROUP_POPUP = 'SHOW_PEERGROUP_POPUP' as const
type ShowPeergroupPopup = PayloadAction<typeof SHOW_PEERGROUP_POPUP, PeergroupPopupDetails>
export const showPeergroupPopupActionCreator = (relationId: PeergroupPopupDetails['relationId'], boundingRect: PeergroupPopupDetails['boundingRect']) =>
  createPayloadAction(SHOW_PEERGROUP_POPUP, { relationId, boundingRect })

export const HIDE_PEERGROUP_POPUP = 'HIDE_PEERGROUP_POPUP' as const
type HidePeergroupPopup = PayloadAction<typeof HIDE_PEERGROUP_POPUP, PopupRelationId>
export const hidePeergroupPopupActionCreator = (relationId: PopupRelationId) =>
  createPayloadAction(HIDE_PEERGROUP_POPUP, relationId)

export const SET_SHOWN_SIDEBAR_PANE = 'SET_SHOWN_SIDEBAR_PANE' as const
type SetShownSidebarPane = PayloadAction<typeof SET_SHOWN_SIDEBAR_PANE, SidebarState['shownPane']>
export const setShownSidebarPaneActionCreator = (shownPane: SidebarState['shownPane']) =>
  createPayloadAction(SET_SHOWN_SIDEBAR_PANE, shownPane)

export const REGISTER_PEERGROUP_POPUP_TIMEOUT = 'REGISTER_PEERGROUP_POPUP_TIMEOUT' as const
type RegisterPeergroupPopupTimeout = PayloadAction<typeof REGISTER_PEERGROUP_POPUP_TIMEOUT, number>
export const registerPeergroupPopupTimeoutActionCreator = (timeoutId: number) =>
  createPayloadAction(REGISTER_PEERGROUP_POPUP_TIMEOUT, timeoutId)

export const UPDATE_NAVIGATION_COUNTERS = 'UPDATE_NAVIGATION_COUNTERS' as const
export const updateNavigationCountersActionCreator = (counters: Partial<NavigationCountersActual>) =>
  createPayloadAction(UPDATE_NAVIGATION_COUNTERS, counters)
export type UpdateNavigationCounters = ReturnType<typeof updateNavigationCountersActionCreator>

export const SET_NAVIGATION_COUNTERS = 'SET_NAVIGATION_COUNTERS' as const
export const setNavigationCountersActionCreator = (counters: Partial<NavigationCountersActual>) =>
  createPayloadAction(SET_NAVIGATION_COUNTERS, counters)
type SetNavigationCounters = ReturnType<typeof setNavigationCountersActionCreator>

export const STASH_NAVIGATION_COUNTERS = 'STASH_NAVIGATION_COUNTERS' as const
export const stashNavigationCountersActionCreator = (counters: NavigationCountersStash) =>
  createPayloadAction(STASH_NAVIGATION_COUNTERS, counters)
type StashNavigationCounters = ReturnType<typeof stashNavigationCountersActionCreator>

export const UNSTASH_NAVIGATION_COUNTERS = 'UNSTASH_NAVIGATION_COUNTERS' as const
type UnstashNavigationCounters = RequestAction<typeof UNSTASH_NAVIGATION_COUNTERS, {}, {}>
export const unstashNavigationCountersActionCreator = createRequestActionCreators<typeof UNSTASH_NAVIGATION_COUNTERS, {}, {}>(UNSTASH_NAVIGATION_COUNTERS)

type Action =
  | ShowPeergroupCreateForm
  | ShowPeergroupEditForm
  | ClosePeergroupForm
  | EditRelation
  | ShowPeergroupPopup
  | HidePeergroupPopup
  | SetShownSidebarPane
  | RegisterPeergroupPopupTimeout
  | SetNavigationCounters
  | UpdateNavigationCounters
  | StashNavigationCounters
  | UnstashNavigationCounters

export default Action
